var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#949CAF",
    fillRule: "evenodd",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M15.903 13.31a6.843 6.843 0 0 0-1.617-2.182 7.551 7.551 0 0 0-2.382-1.46 7.947 7.947 0 0 0-.59-.201 4.32 4.32 0 1 0-4.629 0c-.198.059-.395.126-.59.2a7.551 7.551 0 0 0-2.381 1.46 6.844 6.844 0 0 0-1.617 2.183 6.328 6.328 0 0 0-.597 2.688.502.502 0 0 0 1.004 0c0-1.556.67-3.022 1.886-4.127a6.55 6.55 0 0 1 2.066-1.266 7.056 7.056 0 0 1 2.53-.467H9.014a7.057 7.057 0 0 1 2.529.467 6.55 6.55 0 0 1 2.066 1.266c1.216 1.105 1.886 2.57 1.886 4.127a.502.502 0 0 0 1.004 0c0-.933-.2-1.837-.597-2.688zM6.656 8.163a3.293 3.293 0 0 1-.97-2.344c0-.885.344-1.718.97-2.344A3.293 3.293 0 0 1 9 2.505c.885 0 1.718.344 2.344.97.626.626.97 1.459.97 2.344 0 .886-.344 1.718-.97 2.344a3.293 3.293 0 0 1-2.324.97h-.04a3.293 3.293 0 0 1-2.324-.97z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 4.5,
    x: 16.087,
    y: 5.25,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 7.5c0-.228.185-.413.412-.413h3.675a.412.412 0 1 1 0 .826h-3.675a.412.412 0 0 1-.412-.413z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvite);
export default __webpack_public_path__ + "static/media/invite.58adfcb0.svg";
export { ForwardRef as ReactComponent };